"use strict";
var _ImageProvider_base64;
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const axios_1 = tslib_1.__importDefault(require("axios"));
const _1 = tslib_1.__importDefault(require("."));
const lodash_get_1 = tslib_1.__importDefault(require("lodash.get"));
class ImageProvider {
    constructor(base64) {
        _ImageProvider_base64.set(this, void 0);
        this.image_id = '';
        tslib_1.__classPrivateFieldSet(this, _ImageProvider_base64, base64 || '', "f");
    }
    async upload() {
        if (tslib_1.__classPrivateFieldGet(this, _ImageProvider_base64, "f") && tslib_1.__classPrivateFieldGet(this, _ImageProvider_base64, "f").includes('base64')) {
            const imageUpload = await _1.default.post('/api/me/image_upload');
            const form = new FormData();
            const blob = this.base64ToBlob(tslib_1.__classPrivateFieldGet(this, _ImageProvider_base64, "f"));
            blob && form.append('file', blob);
            const responseCloudflare = await axios_1.default.post(imageUpload.data.upload_url, form);
            this.image_id = (0, lodash_get_1.default)(responseCloudflare.data, 'result.id', '');
        }
    }
    base64ToBlob(base64String) {
        try {
            // Split the base64 string into two parts
            const parts = base64String.split(';base64,');
            // Hold the content type of the image
            const imageType = parts[0].split(':')[1];
            // Convert base64 to raw binary data held in a string
            const decodedData = atob(parts[1]);
            // Create an array buffer to hold the data
            const arrayBuffer = new ArrayBuffer(decodedData.length);
            // Create a view to manipulate the array buffer
            const uint8Array = new Uint8Array(arrayBuffer);
            // Fill the array buffer with the decoded base64 data
            for (let i = 0; i < decodedData.length; i++) {
                uint8Array[i] = decodedData.charCodeAt(i);
            }
            // Create the blob object with the array buffer and content type
            return new Blob([arrayBuffer], { type: imageType });
            // eslint-disable-next-line no-empty
        }
        catch {
            return null;
        }
    }
}
exports.default = ImageProvider;
_ImageProvider_base64 = new WeakMap();
//# sourceMappingURL=ImageProvider.js.map